import { Navigate, Route, Routes } from "react-router-dom";
import { useSession } from "./hooks/useSession";
import { PageShell } from "./components/layout/PageShell";
import { LoginPage } from "./routes/LoginPage";
import { DashboardPage } from "./routes/DashboardPage";
import { OrdersPage } from "./routes/OrdersPage";
import { OrderDetailPage } from "./routes/OrderDetailPage";
import { NewOrderPage } from "./routes/NewOrderPage";
import { RemindersPage } from "./routes/RemindersPage";
import { ClientsPage } from "./routes/ClientsPage";
import { LeadsPage } from "./routes/LeadsPage";
import { ReportsPage } from "./routes/ReportsPage";

export default function App() {
  const { session, loading } = useSession();

  if (loading) {
    return <div className="app-loading">Завантаження…</div>;
  }

  if (!session) {
    return (
      <Routes>
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }

  return (
    <PageShell>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/new" element={<NewOrderPage />} />
        <Route path="/orders/:orderId" element={<OrderDetailPage />} />
        <Route path="/reminders" element={<RemindersPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </PageShell>
  );
}
